import { useState } from 'react';
import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';

interface OtpStorageData {
  otpId: string | null;
  otpCode: string | null;
}

export const useOtpStorage = () => {
  const OTP_STORAGE_KEY = '@pwa:otp-data';
  
  const getStoredOtpData = (): OtpStorageData => {
    const storedData = ApiLocalStorage.get(OTP_STORAGE_KEY);
    
    if (storedData && typeof storedData === 'object') {
      return storedData;
    }
    
    return {otpId: null, otpCode: null};
  };
  
  const [otpData, setOtpData] = useState<OtpStorageData>(getStoredOtpData);
  
  const setOtpStorageData = (data: Partial<OtpStorageData>) => {
    const newData = {...otpData, ...data};
    // ApiLocalStorage.set já faz o stringify, não fazer antes
    ApiLocalStorage.set(OTP_STORAGE_KEY, newData);
    setOtpData(newData);
  };
  
  const clearOtpData = () => {
    ApiLocalStorage.remove(OTP_STORAGE_KEY);
    setOtpData({otpId: null, otpCode: null});
  };
  
  return {
    otpId: otpData.otpId,
    otpCode: otpData.otpCode,
    setOtpId: (id: string) => setOtpStorageData({otpId: id}),
    setOtpCode: (code: string) => setOtpStorageData({otpCode: code}),
    clearOtpData
  };
};
